import SimpleParallax from "simple-parallax-js/vanilla";

Drupal.behaviors.parallax = {
  isStarted: false,
  attach(context, settings) {
    once('simple-parrallax', 'body', context).forEach(el => {
      const images = document.getElementsByClassName('parallax-image');
      new SimpleParallax(images, {
          delay: 0,
          orientation: 'up',
          scale: 1.8,
          overflow: true,
      });
    });
  },
};
